import { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import { Stack } from '@mui/material';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import dayjs from 'dayjs';
import GlobalSelectFieldWithoutFormik from '../../../../components/mui/GlobalSelectFieldWithoutFormik';
import { employeeDetailsTableHeader, EmpFilterMapper } from './utils/employeeDetailsPageHelper';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getEmployeesDetails } from '../../../../redux/features/dashboardSlice';
import { useSelector } from 'react-redux';

export default function EmployeeDetails() {
  const [searchParams, setSearchParams] = useSearchParams();

  const queryFromDate = searchParams.get('fromDate');
  const queryToDate = searchParams.get('toDate');
  const queryName = searchParams.get('name');

  const [filters, setFilters] = useState({
    fromDate: dayjs().startOf('month').format('YYYY-MM-DD'),
    toDate: dayjs().endOf('month').format('YYYY-MM-DD'),
    empType: { id: -1, value: '' },
    attendance: { id: -1, value: '' },
    company: { id: -1, value: '' },
  });
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const employeeDetailsLoading = useSelector((state) => state.dashboard.emplyeesDetails.loading);
  const employeeDetailsData = useSelector((state) => state.dashboard.emplyeesDetails.data);
  const employeeDetailsMeta = useSelector((state) => state.dashboard.emplyeesDetails.meta);

  const dispatch = useDispatch();

  const filterHelper = (value, key) => {
    if (!value || !key) return;
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    const params = {
      company: filters?.company?.id === -1 ? '' : filters?.company?.id,
      search: tableState?.search,
      roleGroup: filters.empType?.id === -1 ? '' : filters?.empType?.id,
      startDate: filters.fromDate,
      endDate: filters.toDate,
      page: tableState.page,
      limit: tableState.pageSize,
      todaysStatus: filters?.attendance?.id === -1 ? '' : filters.attendance?.id,
    };
    const getEmployeeSignal = dispatch(getEmployeesDetails(params));

    return () => {
      getEmployeeSignal.abort();
    };
  }, [filters, tableState.page, tableState.search, tableState.pageSize, dispatch]);

  useEffect(() => {
    switch (queryName) {
      case 'Total Employees':
        filterHelper({ id: -1, value: '' }, 'empType');
        break;

      case 'Today Present':
        filterHelper({ id: 'present', value: '' }, 'attendance');
        break;

      case 'Total OGA':
        filterHelper({ id: 'oga', value: '' }, 'empType');
        break;

      case 'Total SOGO':
        filterHelper({ id: 'sogo', value: '' }, 'empType');
        break;

      case 'Total CRO':
        filterHelper({ id: 'cro', value: '' }, 'empType');
        break;

      case 'Total CRM':
        filterHelper({ id: 'crm', value: '' }, 'empType');
        break;
      default:
        break;
    }

    filterHelper(dayjs(queryFromDate, 'YYYY-MM-DD').format('YYYY-MM-DD'), 'fromDate');
    filterHelper(dayjs(queryToDate, 'YYYY-MM-DD').format('YYYY-MM-DD'), 'toDate');
  }, [queryName, queryFromDate, queryToDate]);

  return (
    <GlobalWrapper title={'Employee Details'}>
      <Stack gap={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
          <FromAndToDatePicker
            fromDate={filters.fromDate}
            toDate={filters.toDate}
            setFromDate={(v) => filterHelper(dayjs(v).format('YYYY-MM-DD'), 'fromDate')}
            setToDate={(v) => filterHelper(dayjs(v).format('YYYY-MM-DD'), 'toDate')}
            fullWidth
          />
          {EmpFilterMapper.map(({ filterKey, keys, label, value, id, data }) => (
            <GlobalSelectFieldWithoutFormik
              sx={{ width: { xs: '100%', sm: 200 } }}
              key={id}
              keys={keys}
              label={label}
              data={data}
              setDirectChange={(v) => filterHelper(v, filterKey)}
              selectedDetails={filters[filterKey]}
            />
          ))}
        </Stack>
        <GlobalTable
          rows={employeeDetailsData}
          headers={employeeDetailsTableHeader}
          tableState={tableState}
          setTableState={setTableState}
          loading={employeeDetailsLoading}
          meta={employeeDetailsMeta}
          rowUniqueId="userID"
        />
      </Stack>
    </GlobalWrapper>
  );
}
